import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import getClassNames from 'src/common/utils/getClassNames';
import ToggleDecorator from 'src/common/components/ToggleDecorator';

import styles from './SnoozeToggle.module.scss';

export type SnoozeToggleProps = {
  variant: 'individual' | 'bulk';
  checked: boolean;
  handleToggle: () => void;
  children: ReactNode;
};

const SnoozeToggle: FC<SnoozeToggleProps> = ({
  variant,
  checked,
  handleToggle,
  children,
}) => {
  const [t] = useTranslation('admin-listings');
  const label = t(`snooze-listing--toggle-label-${variant}`);
  return (
    <div className={styles.root}>
      <label className={styles.label}>
        {label}
        <ToggleDecorator>
          <input
            checked={checked}
            type="checkbox"
            onChange={handleToggle}
          />
        </ToggleDecorator>
      </label>
      <hr
        className={getClassNames(styles, 'divider', variant)}
      />
      {children}
    </div>
  );
};

export default SnoozeToggle;
